import { DATE_SHORT_FORMAT } from '../../../../../../constants/date'
import { EntityStatus } from '../../../../../Entity'
import { RentalPortalApplicantIdentityCell } from '../../../../../RentalPortalApplicant'
import {
  TableCellBase,
  TableDateCell,
  TableEmptyCell,
  TableTextCell,
} from '../../../../../Table'
import { RentalPortalApplicantPortalCell } from '../../../../RentalPortalApplicantPortalCell'
import { getApplicantWithHighlightBudget } from '../../../../RentalPortalApplicants'
import {
  RentalPortalMatchChipsCell,
  RentalPortalMatchCriteriaPopover,
  RentalPortalMatchFitCell,
} from '../../../../RentalPortalMatch'
import { RentalPortalWaitingOnCell } from '../../../../RentalPortalWaitingOnCell'
import {
  LISTING_APPLICANT_COLUMN_NAME,
  LISTING_APPLICANT_STAGES,
} from '../RentalPortalListingProfileApplicants.constants'

export function renderListingProfileApplicantsCell({
  item,
  name,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case LISTING_APPLICANT_COLUMN_NAME.Applicant:
      return (
        <RentalPortalApplicantIdentityCell
          {...restProps}
          applicant={getApplicantWithHighlightBudget(item)}
        />
      )

    case LISTING_APPLICANT_COLUMN_NAME.Chips:
      return item.match ? (
        <TableCellBase {...restProps}>
          <RentalPortalMatchChipsCell match={item.match} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case LISTING_APPLICANT_COLUMN_NAME.Fit:
      return value ? (
        <TableCellBase {...restProps}>
          <RentalPortalMatchCriteriaPopover match={value}>
            <RentalPortalMatchFitCell match={value} />
          </RentalPortalMatchCriteriaPopover>
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case LISTING_APPLICANT_COLUMN_NAME.Stage:
      return LISTING_APPLICANT_STAGES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={LISTING_APPLICANT_STAGES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case LISTING_APPLICANT_COLUMN_NAME.Received:
      return (
        <TableDateCell
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          useTodayFormat={false}
          value={value}
        />
      )

    case LISTING_APPLICANT_COLUMN_NAME.WaitingOn:
      return (
        <RentalPortalWaitingOnCell {...restProps} attention={item.attention} />
      )

    case LISTING_APPLICANT_COLUMN_NAME.Portal:
      return value ? (
        <RentalPortalApplicantPortalCell {...restProps} applicant={item} />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case LISTING_APPLICANT_COLUMN_NAME.Viewing:
      return <TableEmptyCell {...restProps} />

    default:
      return <TableTextCell {...restProps} value={value} />
  }
}
